import { DataSource, HorizontalSpacer, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutSaferWatchControl extends Layout {
    horizontalspacer1: HorizontalSpacer;
    panelServer: Panel;
    sourceCarrierInsControl: DataSource;
    switchIsActive: Switch;
    switchSendCarriers: Switch;
    textboxCarrierStatus: Textbox;
    textboxEmail: Textbox;
    textboxLastSyncDate: Textbox;
    textboxPassword: Textbox;
    textboxSaferwatchLastUpdate: Textbox;
    textboxServer: Textbox;
    textboxUserId: Textbox;
}
